import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { nop } from "../../utils";

export const YesNoButton = (props) => {
    const { value, setValue = nop, disabled = false } = props;
    const { t } = useTranslation();

    return (
        <Button variant="outlined" onClick={() => setValue(!value)} disabled={disabled}>
            {t(value ? "common.yes" : "common.no")}
        </Button>
    );
};
